import React, { Component } from 'react';
import { Container } from './styles';

import Star from '../../assets/emojis/star/star@3x.png';
import Cupom from '../../assets/emojis/cupom/cupom@3x.png';
import Combo from '../../assets/emojis/combo/combo@3x.png';
import Carrinho from '../../assets/emojis/carrinho/carrinho@3x.png';
import Entrega from '../../assets/emojis/entrega/entrega@3x.png';

import ComboBanner from '../../assets/campanhas/default/combo/combo@3x.png';
import CupomBanner from '../../assets/campanhas/default/cupom/cupom@3x.png';
import NovidadesBanner from '../../assets/campanhas/default/novidades/novidades@3x.png';
import EntregaBanner from '../../assets/campanhas/promote/entrega/entrega@3x.png';
import PromosBanner from '../../assets/campanhas/promote/promos/promos@3x.png';

import { IoMdCloseCircle, IoMdCheckmarkCircle } from 'react-icons/io';

import { Link, Redirect } from 'react-router-dom';
import Modal from 'react-modal';
import { toast, Slide, ToastContainer } from 'react-toastify';
import '../../css/ReactToastify.css';

import ModalNovidades from './ModalNovidades';
import ModalCombos from './modalCombos';
import ModalPromocoesProdutos from './modalPromocoesProdutos';

export default class Promocoes extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loaded: true,
            redirect_to_entrega: false,
            campanhas: [
                // {
                //     id: 1,
                //     name: "Dia das mães",
                //     description: "Promocione seus produtos para essa data especial.",
                //     image: "",
                //     emoji: ""
                // },
                // {
                //     id: 2,
                //     name: "Sexta-feira Maluca",
                //     description: "Promova descontos e tenha até 20%OFF",
                //     image: "",
                //     emoji: ""
                // }
            ],
            modalNovidades: false,
            modalCombos: false,
            modalPromocoesProdutos: false,
            token: null,
            superUser: false,
            permission: null
        }
    }

    async componentDidMount() {
        toast.configure();
        Modal.setAppElement('body');
        const token = await localStorage.getItem('@jwt');
        const isSuser = await localStorage.getItem('@internal');
        this.setState({ token });
        if (isSuser) {
            const permissions = await JSON.parse(localStorage.getItem('@suser'));
            this.setState({ superUser: true, permission: permissions.promocoes });
        }
    }

    controllerModalNovidades() {
        const state = this.state.modalNovidades;
        this.setState({
            modalNovidades: !state
        });
    }

    controllerModalCombos() {
        const state = this.state.modalCombos;
        this.setState({
            modalCombos: !state
        });
    }

    controllerModalPromocoesProdutos() {
        const state = this.state.modalPromocoesProdutos;
        this.setState({
            modalPromocoesProdutos: !state
        });
    }

    success = () => {
        toast.dismiss();
        const ToastSuccess = () => (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                justifyContent: 'center'
            }}>
                <div>
                    <IoMdCheckmarkCircle color="#51db74" size={28} />
                </div>
                <div style={{ paddingLeft: 16 }}>
                    <span style={{
                        fontFamily: 'Montserrat',
                        color: "#5b8e3e",
                        fontSize: 16,
                        textAlign: 'center'
                    }}>As alterações foram salvas com sucesso.</span>
                </div>
            </div>
        );
        toast.success(<ToastSuccess />, {
            position: toast.POSITION.BOTTOM_CENTER,
            hideProgressBar: true,
            autoClose: 8000,
            closeButton: false,
            pauseOnHover: false,
            transition: Slide,
        });
    }
    error = () => {
        toast.dismiss();
        const ToastError = () => (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                justifyContent: 'center'
            }}>
                <div>
                    <IoMdCloseCircle color="#d2252e" size={28} />
                </div>
                <div style={{ paddingLeft: 16 }}>
                    <span style={{
                        fontFamily: 'Montserrat',
                        color: "#983236",
                        fontSize: 16,
                        textAlign: 'center'
                    }}>Ocorreu um erro. Tente novamente mais tarde.</span>
                </div>
            </div>
        );
        toast.error(<ToastError />, {
            position: toast.POSITION.BOTTOM_CENTER,
            hideProgressBar: true,
            autoClose: 8000,
            closeButton: false,
            pauseOnHover: false,
            transition: Slide
        });
    }
    customError = (text) => {
        toast.dismiss();
        const ToastError = () => (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                justifyContent: 'center'
            }}>
                <div>
                    <IoMdCloseCircle color="#d2252e" size={28} />
                </div>
                <div style={{ paddingLeft: 16 }}>
                    <span style={{
                        fontFamily: 'Montserrat',
                        color: "#983236",
                        fontSize: 16,
                        textAlign: 'center'
                    }}>{text}</span>
                </div>
            </div>
        );
        toast.error(<ToastError />, {
            position: toast.POSITION.BOTTOM_CENTER,
            hideProgressBar: true,
            autoClose: 8000,
            closeButton: false,
            pauseOnHover: false,
            transition: Slide
        });
    }

    render() {
        const { redirect_to_entrega } = this.state;

        if (redirect_to_entrega) {
            return <Redirect to='/configuracoes/entrega' />;
        }
        return (
            <Container>
                <ToastContainer limit={1} />
                <Modal
                    isOpen={this.state.modalNovidades}
                    // onAfterOpen={this.controllerModal(this.state.isOpen)}
                    onRequestClose={() => this.controllerModalNovidades()}
                    shouldCloseOnEsc={false}
                    shouldCloseOnOverlayClick={false}
                    closeTimeoutMS={100}
                    style={modalStyle}
                    contentLabel="Modal de Novidades"
                >
                    <ModalNovidades
                        success={() => this.success()}
                        error={() => this.error()}
                        customError={(text) => this.customError(text)}
                        closeModal={() => this.controllerModalNovidades()}
                        token={this.state.token}
                    />
                </Modal>

                <Modal
                    isOpen={this.state.modalCombos}
                    // onAfterOpen={this.controllerModal(this.state.isOpen)}
                    onRequestClose={() => this.controllerModalCombos()}
                    shouldCloseOnEsc={false}
                    shouldCloseOnOverlayClick={false}
                    closeTimeoutMS={100}
                    style={modalStyle}
                    contentLabel="Modal de Novidades"
                >
                    <ModalCombos
                        success={() => this.success()}
                        error={() => this.error()}
                        customError={(text) => this.customError(text)}
                        closeModal={() => this.controllerModalCombos()}
                        token={this.state.token}
                    />
                </Modal>

                <Modal
                    isOpen={this.state.modalPromocoesProdutos}
                    // onAfterOpen={this.controllerModal(this.state.isOpen)}
                    onRequestClose={() => this.controllerModalPromocoesProdutos()}
                    shouldCloseOnEsc={true}
                    shouldCloseOnOverlayClick={true}
                    closeTimeoutMS={100}
                    style={modalStyle}
                    contentLabel="Modal de Novidades"
                >
                    <ModalPromocoesProdutos
                        success={() => this.success()}
                        error={() => this.error()}
                        customError={(text) => this.customError(text)}
                        closeModal={() => this.controllerModalPromocoesProdutos()}
                        token={this.state.token}
                    />
                </Modal>


                <div className="div-pai">
                    <div className="div-rota">
                        <Link
                            style={{ textDecoration: 'none' }}
                            to={'/'}>
                            <span
                                className="rotas" >
                                Início
                            </span>
                        </Link>

                        <span className="rotas"> {'>'} </span>

                        <Link
                            style={{ textDecoration: 'none' }}
                            to={'/promocoes'}>
                            <span>
                                Promoções
                            </span>
                        </Link>

                    </div>

                    <div className="titulo">

                        <img alt="" className="emoji" src={Star} />

                        <h1>Promoções</h1>

                        <h5>Acompanhe e configure as suas promoções.</h5>

                    </div>

                    <hr className="linha" />

                    <div className="campanhas">
                        {/* será liberado futuramente */}
                        {/* <h2>Campanhas appedidos</h2>

                        <div className="campanhas-appedidos">
                            {!!this.state.campanhas.length && (
                                this.state.campanhas.map(item => (
                                    <div className="campanha-grande" key={item.id}>
                                        <img src={item.image} alt={item.name} />
                                    </div>
                                ))
                            )}
                        </div>

                        <h2>Campanhas padrão</h2>

                        <div className="campanhas-padrao">
                            <div className="campanha-pequena">
                                <img
                                    className="banner"
                                    src={ComboBanner}
                                    alt="Combo de produtos" />
                                <div className="content">
                                    <img src={Combo} alt="Combo" />
                                    <div className="content-black">
                                        <p>Combo de produtos</p>
                                        <span>Monte o combo perfeito para o seu cliente.</span>
                                    </div>
                                    <button onClick={() => this.controllerModalCombos()}>Ver mais</button>
                                </div>
                            </div>
                            <div className="campanha-pequena">
                                <img
                                    className="banner"
                                    src={CupomBanner}
                                    alt="Cupom" />
                                <div className="content">
                                    <img src={Cupom} alt="Cupom" />
                                    <div className="content-white">
                                        <p>Cupom</p>
                                        <span>Cupons de desconto para o seu cliente.</span>
                                    </div>
                                    <button>Ver mais</button>
                                </div>
                            </div>
                            <div className="campanha-pequena">
                                <img
                                    className="banner"
                                    src={NovidadesBanner}
                                    alt="Novidades & Lançamentos" />
                                <div className="content">
                                    <img src={Star} alt="Novidades" />
                                    <div className="content-white">
                                        <p>Novidades & Lançamento</p>
                                        <span>Não perca tempo, cadastre agora suas novidades!</span>
                                    </div>
                                    <button onClick={() => this.controllerModalNovidades()}>Ver mais</button>
                                </div>
                            </div>
                        </div> */}

                        <h2>Promova o seu restaurante</h2>

                        <div className="promova-o-seu-restaurante">
                            <div className="campanha-pequena">
                                <img
                                    className="banner"
                                    src={EntregaBanner}
                                    alt="Entrega grátis" />
                                <div className="content">
                                    <img src={Entrega} alt="Entrega" />
                                    <div className="content-black">
                                        <p>Entrega grátis</p>
                                        <span>Configure a sua taxa de entrega.</span>
                                    </div>
                                    <button onClick={() => this.setState({ redirect_to_entrega: true })}>Ver mais</button>
                                </div>
                            </div>
                            <div className="campanha-pequena">
                                <img
                                    className="banner"
                                    src={PromosBanner}
                                    alt="Promoções de produto" />
                                <div className="content">
                                    <img src={Carrinho} alt="Carrinho" />
                                    <div className="content-white">
                                        <p>Promoções de produto</p>
                                        <span>Aplique descontos nos seus produtos.</span>
                                    </div>
                                    {/* <button>Ver mais</button> */}
                                    <button onClick={() => this.controllerModalPromocoesProdutos()}>Ver mais</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        )
    }
}

const modalStyle = {
    overlay: {
        position: 'fixed',
        zIndex: 20,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
    },
    content: {
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        maxWidth: '823px',
        height: '100%',
        maxHeight: '826px'
    }
};